export enum CATALOGOS_TYPES {
  // UBICACIONES ----------------------------------------------------
  CATALOGO_SET_DEPARTAMENTOS = 'CATALOGO_SET_DEPARTAMENTOS',
  CATALOGO_SET_MUNICIPIOS = 'CATALOGO_SET_MUNICIPIOS',

  // GENERALES ------------------------------------------------------
  CATALOGO_SET_PLANFACTURAS = 'CATALOGO_SET_PLANFACTURAS',
  CATALOGO_SET_TIPO_ESTABLECIMIENTOS = 'CATALOGO_SET_TIPO_ESTABLECIMIENTOS',
  CATALOGO_SET_ACTIVIDADES_ECONOMICAS = 'CATALOGO_SET_ACTIVIDADES_ECONOMICAS',
  CATALOGO_SET_TIPO_DOCUMENTO = 'CATALOGO_SET_TIPO_DOCUMENTO',
  CATALOGO_SET_TIPO_DOCUMENTOS_EMISION = 'CATALOGO_SET_TIPO_DOCUMENTOS_EMISION',
  CATALOGO_SET_BOTONES_AYUDA = 'CATALOGO_SET_BOTONES_AYUDA',
  CATALOGO_SET_CONDICION_OPERACION_CAT016 = 'CATALOGO_SET_CONDICION_OPERACION_CAT016',
  CATALOGO_SET_TIPO_PERSONA = 'CATALOGO_SET_TIPO_PERSONA',
  CATALOGO_SET_UNIDADES_MEDIDA = 'CATALOGO_SET_UNIDADES_MEDIDA',
  CATALOGO_SET_CONDICIONES_PAGO = 'CATALOGO_SET_CONDICIONES_PAGO',
  CATALOGO_SET_FORMAS_PAGO = 'CATALOGO_SET_FORMAS_PAGO',
  CATALOGO_SET_PLAZOS_PAGO = 'CATALOGO_SET_PLAZOS_PAGO',
  CATALOGO_SET_BANCOS = 'CATALOGO_SET_BANCOS',
  CATALOGO_SET_SERVICIOS_ADICIONALES = 'CATALOGO_SET_SERVICIOS_ADICIONALES',
  CATALOGO_SET_TIPO_CARGOS_MEMBRESIA = 'CATALOGO_SET_TIPO_CARGOS_MEMBRESIA',
  CATALOGO_SET_PRODUCTOS = 'CATALOGO_SET_PRODUCTOS',
  
  // EMISOR ------------------------------------------------------
  GENERAL_DATOS_EMISOR = 'GENERAL_DATOS_EMISOR',

  // CLEAR
  CATALOGOS_CLEAR = 'CATALOGOS_CLEAR',
}
